import React, { useState, useEffect } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import styles from "../assets/css/Dashboard.module.css";
import { FaTrash, FaToilet, FaInfoCircle, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DepartmentTopbar from "./SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "./SuperAdmin/components/DepertmentSidebar";

function Sanitary() {
  const navigate = useNavigate();
  const [sanitaryData, setSanitaryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("");
  useEffect(() => {
    setType(localStorage.getItem("type"));
  }, []);

  const fetchSanitaryData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/SanitaryList`,
        {
          method: "POST",
        }
      );
      const data = await response.json();
      if (data.code === 1) {
        setSanitaryData(data.service_list);
      }
    } catch (error) {
      console.error("Error fetching sanitary data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSanitaryData();
  }, []);

  const handleViewReport = (sanitaryId, sanitaryName) => {
    type === "Sanitary"
      ? navigate(
          `/departmentDashboard/sanitarydetails/${sanitaryId}/${sanitaryName}`
        )
      : navigate(`/sanitarydetails/${sanitaryId}/${sanitaryName}`);
  };

  const getIcon = (name) => {
    switch (name.toLowerCase()) {
      case "dustbin":
        return <FaTrash />;
      case "bio-toilet":
        return <FaToilet />;
      default:
        return <FaToilet />;
    }
  };
  console.log("type", type);
  if (loading) {
    return (
      <>
        {type === "Sanitary" ? <DepartmentTopbar /> : <Topbar />}
        <div className="d-flex">
          <Sidebar />
          <div className={styles.dashboardContainer}>
            <div className={styles.dashboardContent}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {type === "Sanitary" ? <DepartmentTopbar /> : <Topbar />}
      <div className="d-flex">
        {type === "Sanitary" ? <DepartmentSidebar /> : <Sidebar />}
        <div className={styles.dashboardContainer}>
          <div className={styles.dashboardContent}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2
                className="mb-0"
                style={{
                  color: "#2c3e50",
                  fontWeight: "600",
                  fontSize: "1.8rem",
                }}
              >
                Sanitary Management
              </h2>
            </div>
            <div className="row g-4">
              {sanitaryData.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div
                    className="card h-100"
                    style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      background: "linear-gradient(145deg, #ffffff, #f8f9fa)",
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-4">
                        <div
                          className="icon-wrapper me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "12px",
                            background:
                              "linear-gradient(45deg, #2196F3, #1976D2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                          }}
                        >
                          {getIcon(item.sanitary_name)}
                        </div>
                        <h5
                          className="mb-0"
                          style={{
                            color: "#2c3e50",
                            fontWeight: "600",
                          }}
                        >
                          {item.sanitary_name}
                        </h5>
                      </div>

                      <div className="row g-3 mb-4">
                        <div className="col-12">
                          <div
                            className="stat-card p-3 text-center"
                            style={{
                              background: "rgba(33, 150, 243, 0.1)",
                              borderRadius: "10px",
                            }}
                          >
                            <FaInfoCircle className="text-primary mb-2" />
                            <h6 className="mb-1">
                              Total {item.sanitary_name}s
                            </h6>
                            <p className="mb-0 fw-bold">{item.total_tank}</p>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end align-items-center">
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            handleViewReport(
                              item.sanitary_id,
                              item.sanitary_name
                            )
                          }
                          style={{
                            background:
                              "linear-gradient(45deg, #2196F3, #1976D2)",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <FaFileAlt />
                          View Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sanitary;
